export const DAY_PERIOD_TYPE_ID = 1;
export const WEEK_PERIOD_TYPE_ID = 2;
export const MONTH_PERIOD_TYPE_ID = 3;
export const QUARTER_PERIOD_TYPE_ID = 4;
export const YEAR_PERIOD_TYPE_ID = 5;
